import { provideZonelessChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { registerLicense } from '@syncfusion/ej2-base';
import { App } from './app/app';
import { appConfig } from './app/app.config';

registerLicense(
  'Ngo9BigBOggjHTQxAR8/V1JGaF5cXGpCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWH1cd3VVR2NYU012XUBWYEs='
);
bootstrapApplication(App, { ...appConfig, providers: [provideZonelessChangeDetection(), ...appConfig.providers] }).catch((err) => console.error(err));
